import React from "react";
import { Lexeme } from "@bumble/localization/components";
import { Theme } from "ui/themes";
import {
  AmpArticle,
  AmpDownloadApp,
  AmpPage,
  AmpRelatedArticle,
  AmpRelatedArticles,
  AmpSidebar,
  AmpAnalytics,
} from "components/amp";
import PageAmpHeader from "components/page-amp-header";
import PageAmpMobileMenu from "components/page-amp-mobile-menu";
import { IOS_URL, ANDROID_URL, PID, setAppsFlayerURL } from "lib/constants";

export default function ArticleAmpPage(props: any) {
  const { imageUrl, theme, title, url, category, content, relatedPosts } =
    props;

  const articleProps = {
    imageUrl,
    category,
    title,
    content,
  };

  const relatedArticlesList =
    relatedPosts && relatedPosts.length
      ? relatedPosts.map((post: any, index: any) => (
          <AmpRelatedArticle
            title={post.title}
            url={post.url}
            key={`article-0${index}`}
          />
        ))
      : null;

  const relatedArticles =
    relatedPosts && relatedPosts.length ? (
      <AmpRelatedArticles
        title={<Lexeme path="helpcenter@topic.link" />}
        articles={<>{relatedArticlesList}</>}
      />
    ) : null;

  // @todo - add dynamic url
  const campaign = url || "virtual-dating-intimacy"; // url of article
  const iosUrl = setAppsFlayerURL(IOS_URL, PID, campaign);
  const androidUrl = setAppsFlayerURL(ANDROID_URL, PID, campaign);

  return (
    <>
      <AmpAnalytics />
      <AmpSidebar
        theme={theme}
        mobileMenu={<PageAmpMobileMenu />}
        action={
          <AmpDownloadApp
            iosUrl={iosUrl}
            iosTitle={<Lexeme path="bma_client@download_app_ios" />}
            androidUrl={androidUrl}
            androidTitle={<Lexeme path="bma_client@download_app_android" />}
          />
        }
      />
      <AmpPage
        theme={theme}
        header={<PageAmpHeader iosUrl={iosUrl} androidUrl={androidUrl} />}
        article={
          <AmpArticle
            imageUrl={articleProps.imageUrl}
            category={articleProps.category}
            title={articleProps.title}
            content={articleProps.content}
          />
        }
        relatedArticles={relatedArticles}
      />
    </>
  );
}

ArticleAmpPage.Theme = Theme;
